import { createClient } from '@supabase/supabase-js';

// Robust environment variable loading for Vite/Browser environments
const getEnv = (key: string) => {
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
        return import.meta.env[key];
    }
    // Fallback for non-Vite environments if any
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
        return process.env[key];
    }
    return '';
};

const supabaseUrl = getEnv('VITE_SUPABASE_URL');
const supabaseAnonKey = getEnv('VITE_SUPABASE_ANON_KEY');

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('⚠️ Supabase environment variables are missing. Auth and database features will use placeholders and may fail.');
}

export const supabase = createClient(
    supabaseUrl || 'https://xduawymidagalhwajlqo.supabase.co',
    supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhkdWF3eW1pZGFnYWxod2FqbHFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI4NDkxMDksImV4cCI6MjA3ODQyNTEwOX0.LKu6lF7bCZRiA74tznXfV7ZhRwUmceGFLKmAmw1VSFI'
);
